export default __webpack_public_path__ + "static/media/stannis.22bfe94a.jpg";